import type { RefObject } from "react";
import { useEffect, useRef } from "react";
import { DivContainer } from "./style";
import { UserMenus } from "~/components/blocks/layout/global-navi/common/user-menu";

type UserMenuProps = {
  userMenuButtonRef: RefObject<HTMLButtonElement>;
  onHideUserMenu: () => void;
};

export const UserMenu = ({ userMenuButtonRef, onHideUserMenu }: UserMenuProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const bodyElement = document.body;
    const scope = ref.current;
    const userMenuButtonElement = userMenuButtonRef.current;

    if (!bodyElement || !scope || !userMenuButtonElement) return;
    const listener = (event: PointerEvent) => {
      // タッチした要素がアイコンor要素内
      if (userMenuButtonElement.contains(event.target as HTMLElement) || scope.contains(event.target as HTMLElement))
        return;
      //タッチした要素が要素外
      if (!scope.contains(event.target as HTMLElement)) {
        onHideUserMenu();
      }
    };

    bodyElement.style.overflow = "hidden";
    bodyElement.addEventListener("pointerdown", listener, { passive: true });

    return () => {
      bodyElement.style.overflow = "";
      bodyElement.removeEventListener("pointerdown", listener);
    };
  }, []);

  return (
    <DivContainer ref={ref}>
      <UserMenus onHideUserMenu={onHideUserMenu} />
    </DivContainer>
  );
};
